import React from 'react';
import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';

export const STEPS = [
    'PACKAGE',
    'THEME',
    'DATE_TIME',
    'ADDONS',
    'CUSTOMER',
    'REVIEW',
];

interface StepProgressBarProps {
    currentStepIndex: number;
    steps: string[];
}

export const StepProgressBar: React.FC<StepProgressBarProps> = ({ currentStepIndex, steps }) => {
    return (
        <div className="relative flex justify-between w-full max-w-4xl mx-auto mb-16">
            {/* Progress Line Layer */}
            <div className="absolute top-4 left-0 w-full h-[2px] bg-white/15 -z-10" />
            <div
                className="absolute top-4 left-0 h-[2px] bg-primary transition-all duration-700 ease-in-out -z-10"
                style={{ width: `${(currentStepIndex / (steps.length - 1)) * 100}%` }}
            />

            {steps.map((step, idx) => {
                const isActive = idx <= currentStepIndex;
                const isCurrent = idx === currentStepIndex;
                const isCompleted = idx < currentStepIndex;

                return (
                    <div key={step} className="flex flex-col items-center gap-3">
                        <div
                            className={cn(
                                "w-9 h-9 rounded-full flex items-center justify-center border transition-all duration-500",
                                isActive
                                    ? "border-primary bg-primary text-primary-foreground shadow-[0_10px_30px_rgba(0,0,0,0.3)]"
                                    : "border-white/20 bg-white/[0.05] text-muted-foreground",
                                isCurrent && "ring-4 ring-primary/15"
                            )}
                        >
                            {isCompleted ? (
                                <Check className="w-4 h-4" />
                            ) : (
                                <span className="text-[10px] font-medium tracking-tighter">{idx + 1}</span>
                            )}
                        </div>
                        <span className={cn(
                            "text-[9px] uppercase tracking-[0.2em] font-medium transition-colors duration-300",
                            isActive ? "text-foreground" : "text-muted-foreground/75"
                        )}>
                            {step.replace('_', ' ')}
                        </span>
                    </div>
                );
            })}
        </div>
    );
};
